<template>
    <div class="FAQ-model useInfo-model">
        <div class="FAQ-model-content scroll-container">
            <div class="FAQ-model-question" v-html="faq.question">
            </div>
            <div class="FAQ-model-answer">
                <div v-html="faq.answer"></div>
                <div class="FAQ-model-button" v-if="faq.buttonName&&faq.buttonName.length>0"> 
                    <a class="external"
                    :href="faq.url" external=""
                    target="_blank">{{faq.buttonName}}</a> 
                </div>
            </div>
            <div class="FAQ-model-close js-closeModelBtn" @click.stop="closePopup" v-show="!isShowNagtivePopup">
                <img src="https://resource.rcclchina.com.cn/Faq/closed.png" alt="弹窗关闭图标">
            </div>
            <div class="useInfo-chioce js-useSelect">
                <div :class="{ active: faq.suggestionType == 1}" @click="onSuggestionClick(1)">
                    <img class="useInfo-icon" src="https://resource.rcclchina.com.cn/Faq/useIconN.png" alt="有用">
                    <img class="useInfo-iconActive" src="https://resource.rcclchina.com.cn/Faq/useIconWN.png" alt="有用">
                    <span>有用</span>
                </div>
                <div class="modelActive" :class="{ active: faq.suggestionType == 2}" @click="onSuggestionClick(2)">
                    <img class="useInfo-icon" src="https://resource.rcclchina.com.cn/Faq/nouseIconN.png" alt="没用">
                    <img class="useInfo-iconActive" src="https://resource.rcclchina.com.cn/Faq/nouseIconWN.png" alt="没用">
                    <span>没用</span>
                </div>
            </div>
        </div>

        <div class="useInfo-model-content" v-show="isShowNagtivePopup==true">
            <div class="popupover3-bg"></div>
            <div class="useInfo-model-wrapper">
                <div class="useInfo-resonsTitle">您认为没用的信息：</div>
                <div class="useInfo-model-close js-closeModelBtn" @click.stop="isShowNagtivePopup=false">
                    <img src="https://resource.rcclchina.com.cn/Faq/closed.png" alt="弹窗关闭图标" class="">
                </div>
                <div class="useInfo-resons">
                    <ul class="useInfo-resonsCon">
                        <li v-for="(item, i) in nagtiveItems" :key="('nagtiveItem_'+i)" @click="selectedNagtiveItem=item">
                            <input type="radio" name="useInfo" class="js-radioBtn" :checked="item==selectedNagtiveItem">
                            <span class="js-radioBtn">{{item}}</span>
                        </li>
                    </ul>
                    <div class="useInfo-resonsSubmit">
                        <button class="js-reasonSubmit" @click="onNagtiveSubmit">提交</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "FaqDetailPopup",
    props: {
        faq: {
            type: Object
        },
        selectedShipCategory: {
            type: Object
        },
        onPopupClose: {
            type: Function
        },
        onFaqFeedbackSuccess: {
            type: Function
        }
    },
    data () {
        return {
            isShowNagtivePopup: false,
            nagtiveItems: [
                "信息有误",
                "信息不全",
                "描述有歧义",
                "问题和答案不符",
                "不是我想要的信息"
            ],
            selectedNagtiveItem: "",
            isSubmitting: false
        }
    },
    methods: {
        closePopup () {
            this.isShowNagtivePopup = false
            this.onPopupClose()
        },
        async onSuggestionClick (type) {
            if (this.faq.suggestionType > 0) {
                if (this.faq.suggestionType == type && type == 1) {
                    // cancel
                    if (!this.isSubmitting) {
                        const rewardToken = this.$store.state.user.userReviewToken
                        const requestData = {
                            faqId: this.faq.id,
                            userName: rewardToken,
                            shipCategory: this.selectedShipCategory.title,
                            shipSubCategory: this.selectedShipCategory.subTitle
                        }
                        this.isSubmitting = true
                        const { success, data } = await api.page.cancelFaqFeedback(requestData)
                        this.isSubmitting = false
                        if (success) {
                            this.onFaqFeedbackSuccess(this.faq.id, 0)
                        }
                        if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                            this.$store.commit('SET_REWARD_TOKEN', data.token)
                        }
                    }
                }
            } else if (type == 2) {
                this.isShowNagtivePopup = true
            } else {
                // submit positive
                if (!this.isSubmitting) {
                    const rewardToken = this.$store.state.user.userReviewToken
                    const requestData = {
                        faqId: this.faq.id,
                        userName: rewardToken,
                        shipCategory: this.selectedShipCategory.title,
                        shipSubCategory: this.selectedShipCategory.subTitle,
                        isGood: true
                    }
                    this.isSubmitting = true
                    const { success, data } = await api.page.submitFaqFeedback(requestData)
                    this.isSubmitting = false
                    if (success) {
                        this.onFaqFeedbackSuccess(this.faq.id, 1)
                    }
                    if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                        this.$store.commit('SET_REWARD_TOKEN', data.token)
                    }
                }
            }
        },
        async onNagtiveSubmit () {
            if (!this.selectedNagtiveItem && this.selectedNagtiveItem.length == 0) {
                this.$alert.show("请选择您认为没用的信息")
                return
            }
            if (!this.isSubmitting) {
                const rewardToken = this.$store.state.user.userReviewToken
                const requestData = {
                    faqId: this.faq.id,
                    userName: rewardToken,
                    shipCategory: this.selectedShipCategory.title,
                    shipSubCategory: this.selectedShipCategory.subTitle,
                    isGood: false,
                    suggestion: this.selectedNagtiveItem
                }
                this.isSubmitting = true
                const { success, data } = await api.page.submitFaqFeedback(requestData)
                this.isSubmitting = false
                if (success) {
                    this.onFaqFeedbackSuccess(this.faq.id, 2)
                    this.isShowNagtivePopup = false
                }
                if (data && data.token && data.token.length > 0 && data.token != rewardToken) {
                    this.$store.commit('SET_REWARD_TOKEN', data.token)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>

/**** 问答弹窗 ****/
.FAQ-model {
    position:fixed;
    top:0;
    left:0;
    background-color:rgba(0,0,0,.4);
    z-index:1111;
    width:100%;
    height:100%;
}
.FAQ-model .FAQ-model-content{
    width:93.6%;
    padding:7px 10px;
    position:relative;
    left:3.2%;
    top:142px;
    background-color:#fff;
}
.FAQ-model .FAQ-model-content .FAQ-model-question{
    color:#061556;
    font-size:13px;
    padding-bottom:7px;
    border-bottom:1px solid #acacac;
    padding-right:24px;
}


.FAQ-model .FAQ-model-content .FAQ-model-close{
    position: absolute;
    right: 5px;
    top: 5px;
    width: 23px;
    height: 23px;
    z-index: 1111;
}
.FAQ-model .FAQ-model-content .FAQ-model-close img{
    width:100%;
}

/**** 有用没用 ****/
.useInfo-chioce {
    width: 100%;
    height: 44px;
    line-height: 44px;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
    background-color: #f3f3f3;
}
.useInfo-chioce>div {
    width:50%;
    float:left;
    text-align:center;
}
.useInfo-chioce > div:first-child {
    border-right: 1px solid #dcd9d9;
}
.useInfo-chioce>div img {
    width:16px;
    vertical-align:middle;
}
.useInfo-chioce>div img.useInfo-icon{
    display:inline-block;
}
.useInfo-chioce>div img.useInfo-iconActive{
    display:none;
}
.useInfo-chioce>div span {
    font-size:12px;
    color:#888;
    vertical-align:middle;
}
.useInfo-chioce>div.active{
    background-color:#1174b8;
}
.useInfo-chioce>div.active img.useInfo-icon{
    display:none;
}
.useInfo-chioce>div.active img.useInfo-iconActive{
    display:inline-block;
}
.useInfo-chioce>div.active span{
    color:#fff;
}

/**** 没用信息提交弹窗 ****/


.useInfo-model .useInfo-model-content {
    width: 93.6%;
    position: absolute;
    left: 3.2%;
    top: 142px;
    background-color: #fff;
}

.useInfo-model .useInfo-model-wrapper {
    position: relative;
    z-index: 1;
    background: white;
    padding: 7px 10px;
}

.useInfo-model .popupover3-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
}

.useInfo-model .useInfo-resonsTitle {
    color: #061556;
    font-size: 13px;
    padding-bottom: 7px;
    border-bottom: 1px solid #acacac;
    padding-right: 24px;
}
.useInfo-model .useInfo-resons ul{
    margin:0;
    list-style:none;
    padding:0;
}
.useInfo-model .useInfo-resons ul li{
    margin-top:6px;
}
.useInfo-model .useInfo-resons ul li input{
    width:16px;
    height:16px;
    vertical-align:middle;
    margin:0;
}
.useInfo-model .useInfo-resons ul li span{
    color:#000;
    font-size:13px;
    margin-left:6px;
    display:inline-block;
    vertical-align:middle;
}
.useInfo-model .useInfo-resonsSubmit{
    text-align:center;
}
.useInfo-model .useInfo-resonsSubmit button{
    margin:0 auto;
    width:70px;
    height:30px;
    line-height:30px;
    color:#000;
    font-size:12px;
    background-color:#fcc300;
    border-radius:4px;
    border:none;
}
.useInfo-model .useInfo-model-close  {
    width:24px;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1112;
}
.useInfo-model .useInfo-model-close img{
    width:100%;
}

.FAQ-model-button a {
    border-radius: 5px;
    background: #fbc300;
    text-align: center;
    line-height: 30px;
    color: #333333;
    font-size: 13px;
    font-weight: 500;
    margin: 8px 0 0 0;
    cursor: pointer;
    padding: 5px 10px;
}
</style>

<style lang="less">
.FAQ-model .FAQ-model-content .FAQ-model-answer{
    font-size:12px;
    color:#666;
    margin-top:15px;
    height:auto;
    max-height:300px;
    overflow-y:auto;
    padding-bottom:44px;
}
.FAQ-model .FAQ-model-content .FAQ-model-answer p>img{
    max-width:100%;
    height:auto;
}
</style>

<style lang="less">
.FAQ-model .FAQ-model-content .FAQ-model-question p{
    margin:0;
}
</style>